import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../FreeCataloges.jsx/FreeCataloge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faShieldHalved,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

const products = [
  { id: 1, name: "T-shirts", image: "./assets/tshirt2.jpeg" },
  { id: 3, name: "Polo Shirts", image: "./assets/tshirt1.jpeg" },
  { id: 5, name: "Hoodies", image: "./assets/hoddies1.jpeg" },
  { id: 6, name: "Casual Wear", image: "./assets/casual%20ware.jpeg" },
  { id: 1, name: "Sports Wear", image: "./assets/sport1.jpeg" },
  { id: 1, name: "T-shirts", image: "./assets/tshirt2.jpeg" },
  { id: 3, name: "Polo Shirts", image: "./assets/tshirt1.jpeg" },
  { id: 5, name: "Hoodies", image: "./assets/hoddies1.jpeg" },
];

const GbrosGarments = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [highlight, setHighlight] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleReachEnd = () => {
    if (swiperInstance) {
      const isEnd = swiperInstance.isEnd;
      const navigationButton = document.querySelector(".swiper-button-next");
      if (navigationButton) {
        navigationButton.style.display = isEnd ? "none" : "block";
      }
    }
  };

  const handleReachStart = () => {
    if (swiperInstance) {
      const isBeginning = swiperInstance.isBeginning;
      const navigationButton = document.querySelector(".swiper-button-prev");
      if (navigationButton) {
        navigationButton.style.display = isBeginning ? "none" : "block";
      }
    }
  };

  const handleProductClick = () => {
    setActiveSection("products");
  };

  const renderContent = () => {
    switch (activeSection) {
      case "products":
        return (
          <div className="swiper-container">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              slidesPerView={1}
              spaceBetween={10}
              pagination={{ clickable: true }}
              navigation={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              onSwiper={setSwiperInstance}
              onReachEnd={handleReachEnd}
              onReachBeginning={handleReachStart}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 4, spaceBetween: 40 },
                1024: { slidesPerView: 7, spaceBetween: 30 },
              }}
              className="mySwiper"
            >
              {products.map((product) => (
                <SwiperSlide key={`product-${product.id}`}>
                  <div className="card" onClick={handleProductClick}>
                    <img src={product.image} alt={product.name} />
                    <p>{product.name}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        );

      default:
        return (
          <div>
            <div className="swiper-container">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{ clickable: true }}
                navigation={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                onSwiper={setSwiperInstance}
                onReachEnd={handleReachEnd}
                onReachBeginning={handleReachStart}
                breakpoints={{
                  640: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  1024: { slidesPerView: 7, spaceBetween: 30 },
                }}
                className="mySwiper"
              >
                {products.map((product) => (
                  <SwiperSlide key={`product-${product.id}`}>
                    <div className="card">
                      <img src={product.image} alt={product.name} />
                      <p>{product.name}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="welcome">
              <h1>Welcome to the GBROS Company</h1>
              <p>
                GBROS is a leading name in the Indian garment manufacturing
                industry, proudly operating from the textile capital of
                India—Tirupur, Tamil Nadu. With 1 year of industry experience,
                GBROS has quickly established a reputation for delivering
                high-quality cotton and fabric t-shirts tailored for men and
                women. The company focuses on maintaining product excellence,
                customer satisfaction, and timely delivery.
              </p>

              <p>
                As a dedicated T-shirt manufacturer, GBROS specializes in
                creating stylish, durable, and comfortable apparel suitable for
                all seasons. Their main product line includes a wide variety of
                Men’s and Women’s t-shirts, crafted from premium-grade cotton.
                These garments are known for their soft texture, breathable
                quality, and modern fits, making them ideal for both casual and
                semi-formal wear. Whether it's round neck, V-neck, polo, or
                custom-printed t-shirts, South Cotton Fabs ensures each piece
                meets stringent quality standards.
              </p>
              <h2>We Deals in All kind of Garments</h2>
              <p>
                Tirupur is globally recognized as a hub for knitwear and garment
                exports, and GBROS proudly contributes to this legacy. By using
                state-of-the-art machinery and skilled manpower, the company
                offers a seamless blend of traditional textile craftsmanship and
                modern apparel trends. Every product is meticulously designed
                and manufactured with attention to fabric selection, stitching
                quality, color fastness, and comfort.
              </p>
              {/* <h2>Our Products :</h2> */}
              <p>
                One of the core strengths of GBROS lies in its customer-centric
                approach. The company is open to bulk orders and offers
                customization options to clients, including logo printing,
                embroidery, and size variations to meet specific business or
                branding needs. Whether it’s for retail, promotional campaigns,
                or uniform requirements, GBROS serves diverse industry verticals
                with reliability. The team at South Cotton Fabs is driven by the
                principles of integrity, innovation, and excellence. They work
                closely with clients to understand their requirements and
                deliver products that match global fashion sensibilities while
                staying cost-effective. Additionally, the company maintains
                ethical business practices and ensures all operations are
                environmentally conscious.
              </p>
              <p>
                With a growing clientele across India, especially among
                startups, fashion retailers, and corporate buyers, South Cotton
                Fabs aims to become a trusted partner in quality t-shirt
                manufacturing. For buyers seeking a dependable supplier of
                cotton and fabric-based t-shirts from Tirupur, D.Y Shredded
                Papers stands as a promising choice.
              </p>
              {/* <p>Unmatched Expertise
                                With years of experience in the elevator industry, our skilled team brings unparalleled knowledge and proficiency to every project.</p> */}

              <li>
                <div className="pro_inner">
                  <div className="pro_img_sec">
                    <img
                      src="./assets/gbgarment1.jpg"
                      title="GBROS  Garments"
                      alt="GBROS  Garments"
                      width="202"
                      height="299"
                      decoding="async"
                    />
                  </div>
                  <div className="products_info">
                    <div className="pro_title">
                      <h3>Premium Cotton Garments</h3>
                    </div>
                    <div className="pro_det_sec">
                      <ul className="attributes">
                        <li>
                          <span>Brand:</span> GBROS
                        </li>
                        <li>
                          <span>Product:</span> Premium Cotton Garments (Men,
                          Women, Kids)
                        </li>
                        <li>
                          <span>Material:</span> Made from 100% soft, breathable
                          cotton for all-day comfort and durability.
                        </li>
                        <li>
                          <span>Fit:</span> Available in Regular and Slim Fit –
                          Tailored to provide a perfect fit for every body type.
                        </li>
                        <li>
                          <span>Sizes:</span> All standard sizes – XS to XXL,
                          suitable for kids, men, and women.
                        </li>
                        <li>
                          <span>Colors:</span> Wide range of vibrant and neutral
                          colors to match every mood and style.
                        </li>
                        <li>
                          <span>Usage:</span> Ideal for casual wear, promotional
                          events, and custom branding needs.
                        </li>
                        <li>
                          <span>Customization:</span> Logo printing and
                          embroidery options available on bulk orders.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="company_header">
        <div className="top_head">
          <div className="company_left zdasds">
            <span className="logo_img2" style={{ background: "#d1d786" }}>
              GB
            </span>

            <div className="company_info">
              <div className="company_name2">
                <h1>
                  GBROS{" "}
                  <div className="_oth_info">
                    <a
                      href="https://www.google.co.in/maps/dir//12.9715987,77.5945627"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <b className="fa fa-map-marker" />
                        Tirupur, Tamil Nadu
                      </span>
                    </a>
                  </div>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_head">
          <div className={`Premium-Header ${highlight ? "highlight" : ""}`}>
            <ul className="menu_sec">
              <li>
                Home <FontAwesomeIcon icon={faGauge} />
              </li>
              <li>
                Products <FontAwesomeIcon icon={faShieldHalved} />
              </li>
              <li>
                About Us <FontAwesomeIcon icon={faMessage} />
                <ul className="dropdown"></ul>
              </li>
              <li>
                Contact Us <FontAwesomeIcon icon={faShieldHalved} />
                <ul className="dropdown"></ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default GbrosGarments;
